
const calculateCartPrices = () => {
  let currentExpectedSurcharge = getCurrentExpectedSurcharge(getCartZipCode());
  if (theme && theme.Currency) {
    $('#asm-surcharche-rate').text(theme.Currency.formatMoney((currentExpectedSurcharge/10.0).toFixed(2)));
  } else {
    let amountTxt = "$" + parseFloat(currentExpectedSurcharge/10.0).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    $('#asm-surcharche-rate').text(amountTxt);
  }
  calculateCartPricesSub();
}

const getNewSubtotalString = (subtotal) => {
  const formattedResult = (subtotal.toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `$${formattedResult}`;
};

const setNewHtmlPrice = (element) => {
  const $el = $(element);
  if ($el.length > 0) {
    const parsedPrice =  getSubtotalFloat($el.html());
    const newPrice = getNewSubtotalString(parsedPrice);
    $el.html(newPrice);
  }
};

const validatePrice = (item) => {
  if(item.length > 0) {
    const floatNum = getSubtotalFloat(item.html());
    if(!isNaN(floatNum)) return floatNum;
  }
  return 0;
};

const getSubtotalFloat =  (stringPrice) => {
  let price = stringPrice.replaceAll(',', '').replaceAll('-','').replaceAll('$', '');
  return parseFloat(price); 
};

const getTotalRPADiscount = (getTotalSurcharge = false) => {
  let totalNegativeRPA = 0;
  let totalExpectedSurcharge = 0;
  const items = $('.variant-rpa-value');
  items.each(function() {
    const surcharge = $(this).val();
    const row = $(this).closest('.cart-item');
    const quantity = row.find('.cart__qty-input').val();
    if(surcharge.includes('-')) {
      const itemRpaDiscount = parseFloat(surcharge.slice(1));
      totalNegativeRPA += itemRpaDiscount;
    }else {
      const itemRpa = parseFloat(surcharge);
      totalExpectedSurcharge += itemRpa;
    }
  });
  totalExpectedSurcharge /= 100;
  if(totalNegativeRPA > 0) {
    totalNegativeRPA /= 100;
    totalExpectedSurcharge -= totalNegativeRPA;
  }
  if(getTotalSurcharge) return totalExpectedSurcharge > 0 ? totalExpectedSurcharge.toFixed(2) : '0';
  return totalNegativeRPA;
}

function calculateCartPricesSub(test=false){
  const listPrices = $('.item-final-price');

  let subtotal = 0;
  let discountAdjustment = 0;
  let subtotalWithDiscount = 0;
  let grandTotal = 0;
  const rpaDiscount = getTotalRPADiscount();
  const discountElement = $('#asm-discount-rate');
  const regionalPriceAdjustmentElement = $('#asm-surcharche-rate');
  const shippingpriceElement = $('#asm-shipping-rate');
  const shippingFreeRate = $('.asm-free-rate');
  const subtotalElement = $('#asm-subtotal-rate');
  const subtotalStickyElement = $('#cart-sticky .cart__subtotal');
  const grandTotalElement = $('#asm-total-rate');
  let discount = validatePrice(discountElement);
  if(discountElement.length) {
    const discountVal = discountElement.attr('initial-discount');
    if(discountVal) {
      discount = parseFloat(discountVal);
    }else {
      discountElement.attr('initial-discount', discount);
    }
    if(Math.abs(discount - rpaDiscount) < 0.01) {
      discount = rpaDiscount;
    }
  }
  const finalDiscount = discount > 0 && rpaDiscount > 0 ? discount - rpaDiscount : 0;
  let regionalPriceAdjustment = validatePrice(regionalPriceAdjustmentElement);
  let shippingPrice = validatePrice(shippingpriceElement);
  
  listPrices.each(function() {
    const item = $(this);
    const itemOriginalHiddenWithRPA = $(this).siblings('.item-original-price'); 
    
    const itemDiscountedTotalPrice = item.attr("variant-total-price");
    subtotal += typeof itemDiscountedTotalPrice !== 'undefined' ? getSubtotalFloat(itemDiscountedTotalPrice) : getSubtotalFloat(item.html());
    discountAdjustment += getSubtotalFloat(itemOriginalHiddenWithRPA.html()) - getSubtotalFloat(item.html());
    
    
  });
  
  subtotal = subtotal + discountAdjustment;
  grandTotal = subtotal + regionalPriceAdjustment + shippingPrice - discount + rpaDiscount;
  const subtotalString = getNewSubtotalString(subtotal, 0, true);
  const grandTotalString = getNewSubtotalString(grandTotal, 0, true);
  const discountString = '-'+getNewSubtotalString(discount, 0, true);
  const shippingPriceString = getNewSubtotalString(shippingPrice, 0, true);
  const finalDiscountString = getNewSubtotalString(finalDiscount, 0, true);
  if(test) {
    console.log(`**** TEST TOTALS START:`);
    assertNumber('subtotal',subtotalString,subtotalElement.html());
    assertNumber('discount',discountString,discountElement.html());
    assertNumber('RPA',grandTotalString,regionalPriceAdjustmentElement.html());
    assertNumber('shipping',shippingPriceString,shippingpriceElement.html());
    assertNumber('grand total',grandTotalString,grandTotalElement.html());
  } else {
    subtotalElement.html(subtotalString);
    subtotalStickyElement.html(grandTotalString);
    grandTotalElement.html(grandTotalString);
    if(discountElement.length && finalDiscount > 0) discountElement.html(`-${finalDiscountString}`);
  }
}

function asm_change_zip_code() {
  if (document.getElementById('asm-ship-to-change')) {
      if (document.getElementById('asm-ship-to-force-zip').style.display == 'none'){
        document.getElementById('asm-ship-to-change-img').src = window.cartCollapse2;
      }else{
        document.getElementById('asm-ship-to-change-img').src = window.cartCollapse;
      }
  }
  if (document.getElementById('asm-ship-to-city-state')) {
      if (document.getElementById('asm-ship-to-city-state').style.display == 'block')
          document.getElementById('asm-ship-to-city-state').style.display = 'none';
      else
          document.getElementById('asm-ship-to-city-state').style.display = 'block'
  }
  if (document.getElementById('asm-ship-to-force-zip')) {
      if (document.getElementById('asm-ship-to-force-zip').style.display == 'none')
          document.getElementById('asm-ship-to-force-zip').style.display = 'block';
      else
          document.getElementById('asm-ship-to-force-zip').style.display = 'none'
  }
}

function asm_set_geo_values(city, state, zip, country) {
  let asm_geo_data = city + '~' + state + '~' + zip + '~' + country;
  sessionStorage.setItem('ASM-Geo-Data', asm_geo_data);
  if (document.getElementById('asm-ship-to-change'))
      document.getElementById('asm-ship-to-change').innerHTML = '<img id="asm-ship-to-change-img" src="'+window.cartCollapse2+'">';
  if (document.getElementById('asm-ship-to-city-state'))
      document.getElementById('asm-ship-to-city-state').innerHTML = city + ', ' + state;
  if (document.getElementById('asm-ship-to-zip'))
      document.getElementById('asm-ship-to-zip').innerHTML = zip;
  if (document.getElementById('asm-force-zip'))
      document.getElementById('asm-force-zip').value = zip;
  if (auto_calc == true)
      asm_mini_cart_shipping(zip, state, country)
}

function checkZipcodeStatus () {
  const inputImg = $('#asm-ship-to-change-img');
  if(inputImg.length > 0 && inputImg.attr('src').includes('arrow-up') && typeof asm_change_zip_code === 'function') asm_change_zip_code();
}

$(document).on("ready", function() {
  asm_change_zip_code();
  checkZipcodeStatus();
})

